import styled from "styled-components";
export const EditForm = styled.div`
  > div {
    margin-bottom: 10px;
  }
  margin-left: 5px;
  margin-right: 5px;
  overflow: scroll;
`;
